import { C as i } from "./utils-CTvTB86_.js";
class h {
  constructor(r, o, s) {
    this.api = r, this.path = o, this.logRequests = s;
  }
  /**
   * Query the API with a GraphQL query.
   * @param query The query to send to the API. Make sure to wrap
   * it in the `graphql` function from "./graphqlGen".
   *
   * After the query is added, run `pnpm generate` to generate the types.
   */
  async post({
    query: r,
    variables: o,
    options: s
  }) {
    return this.makePost(
      r,
      o,
      s
    );
  }
  async makePost(r, o, s = {}) {
    this.logRequests && console.info(
      `[api-platform request] ${r.trim().replace(/\s+/g, " ")}`
    );
    try {
      const t = { query: r, variables: o }, a = await this.api.post({
        endpoint: this.path,
        headers: {
          "Content-Type": "application/json"
        },
        options: s,
        reqBody: JSON.stringify(t)
      });
      if (!a.ok)
        throw new Error(await a.text());
      const e = await a.json();
      if (e.errors !== void 0)
        throw new Error(JSON.stringify(e.errors[0]));
      if (e.data !== void 0)
        return e.data;
      throw new Error(
        "Malformed GraphQL response: no 'data' or 'errors' key"
      );
    } catch (t) {
      throw t instanceof i ? new Error(t.originalErrors?.[0] ?? t.message) : t;
    }
  }
}
export {
  h as GqlClient
};
//# sourceMappingURL=graphql.js.map
